import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import mapAnnotations from 'helper/Meteorology/Weather/Overview/AnomalyPanel/mapAnnotations';
import useDragScroll from 'utils/hooks/useDragScroll';

import './index.scss';

const BASE = '/meteorology/weather/oscillations/';

const TABS = [
  { url: '', label: 'Visão Geral' },
  ...mapAnnotations.map((entry) => ({ url: entry.url, label: entry.acronym })),
];

export default function OscillationTabs() {
  const { pathname } = useLocation();
  const {
    ref,
    dragHandlers: {
      onPointerDown, onPointerMove, onPointerUp, onPointerLeave, onClickCapture,
    },
  } = useDragScroll<HTMLDivElement>();

  const current = pathname.startsWith(BASE) ? pathname.slice(BASE.length) : '';

  return (
    <nav className="oscillation-tabs">
      <div
        className="oscillation-tabs-scroller"
        ref={ref}
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerLeave={onPointerLeave}
        onClickCapture={onClickCapture}
      >
        {TABS.map((tab) => (
          <Link
            key={tab.url || 'overview'}
            to={`${BASE}${tab.url}`}
            className={`oscillation-tabs-item${current === tab.url ? ' active' : ''}`}
          >
            {tab.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}
